/* eslint-disable indent */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import moment from "moment";

const QueryComments = ({ queryComments, commentLoading }) => {
  const showCommentList = (commentArray) => {
    if (
      typeof commentArray !== "undefined" &&
      commentArray !== null &&
      commentArray.length > 0
    ) {
      return commentArray.map((queryComment, index) => (
        <div className="ml-3 mb-2 mt-1 queryComment" key={index}>
          <div className="row">
            <div className="col-md-7 col-xl-7 col-lg-7">
              <strong className=" mb-1">
                {queryComment?.createdBy?.workerFirstName +
                  " " +
                  queryComment?.createdBy?.workerSurname}
              </strong>
              <div>
                Posted on{" "}
                {moment(queryComment?.createdAt).format("DD-MM-YYYY")}
              </div>
            </div>
            <div className="col-md-5 col-xl-5 col-lg-5 text-right ">
              <strong
                className={
                  queryComment?.commentStatus === "IN-PROGRESS"
                    ? "text-primary"
                    : queryComment?.commentStatus === "SOLVED"
                    ? "text-success"
                    : "text-danger"
                }
              >
                {queryComment?.commentStatus === "IN-PROGRESS" ||
                queryComment?.commentStatus === "UNSOLVED"
                  ? `will solve till ${
                      queryComment?.querySolvedDate &&
                      moment(queryComment?.querySolvedDate).format(
                        "DD-MM-YYYY"
                      )
                    }`
                  : `${queryComment?.commentStatus} on ${
                      queryComment?.querySolvedDate &&
                      moment(queryComment?.querySolvedDate).format(
                        "DD-MM-YYYY"
                      )
                    }`}
              </strong>
            </div>
          </div>
          <div className="mb-1 ml-2 mt-2">
            {queryComment?.commentBody}
          </div>
          <div
            className="row mb-1 ml-2 mt-2"
            style={{ flexWrap: "wrap" }}
          >
            {queryComment?.commentScreenshots.map(
              (commentScreenshot, commentScreenshotIndex) => (
                <td key={commentScreenshotIndex}>
                  <a
                    href={commentScreenshot}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Image No {commentScreenshotIndex + 1}
                  </a>
                </td>
              )
            )}
          </div>
        </div>
      ));
    }
  };

  return <Fragment>{showCommentList(queryComments)}</Fragment>;
};

QueryComments.propTypes = {
  queryComments: PropTypes.array.isRequired,
  commentLoading: PropTypes.bool.isRequired
};

export default QueryComments;
